(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/deposit/assets/react/apple-pay/apple-pay.js') >= 0) return;  svs.modules.push('/components/accountservices-react/deposit/assets/react/apple-pay/apple-pay.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  logger
} = svs.accountservicesReact.deposit.applePay;
const {
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle
} = React;
const {
  DepositButton,
  DepositInput,
  OnboardingDepositAmountInfo,
  useSuccessCleanup
} = svs.accountservicesReact.deposit.depositShared;
const {
  APPLEPAY
} = svs.accountservicesReact.deposit.constants.paymentTypes;
const {
  SWEDBANKPAY_CONTAINER_ELEMENT
} = svs.accountservicesReact.deposit.constants;
const {
  CurrencyAsJupiterString: formatCurrencyAsJupiterString
} = svs.utils.format;
const {
  navigateOnPayTrue,
  handleError
} = svs.accountservicesReact.deposit.helpers.sharedHelpers;
const {
  Form
} = svs.ui.reactForm;
const {
  showDepositSuccess
} = svs.accountservicesReact.deposit.dialogs.sharedDialogs;
const {
  amountChangeAction,
  updateSpendLimitRemainingAction
} = svs.accountservicesReact.deposit.store.deposit.actions;
const APPLEPAY_STATE = {
  INIT: 0,
  POLL: 1
};
const baseOptions = {
  el: SWEDBANKPAY_CONTAINER_ELEMENT,
  backButton: true,
  backButtonText: 'Tillbaka',
  backButtonCallback: () => {
    svs.components.analytics.trackEvent({
      category: 'Deposits',
      action: 'Deposit Cancel BackButton',
      opt_label: 'CC ApplePay'
    });
  },
  prefixText: 'Betalningar',
  isNotInfoText: false,
  context: void 0
};
let swedbankPayCheckout;
const formatAndDeposit = amount => {
  const transAmount = formatCurrencyAsJupiterString(amount);
  swedbankPayCheckout.deposit(transAmount, APPLEPAY);
};
const ApplePay = forwardRef((_ref, ref) => {
  let {
    isPlayerRegistration,
    swedbankPayProps
  } = _ref;
  const dispatch = ReactRedux.useDispatch();
  const depositAmount = ReactRedux.useSelector(state => state.deposit.amount);
  const instantPay = ReactRedux.useSelector(state => state.deposit.instantPay);
  const returnUrl = ReactRedux.useSelector(state => state.deposit.returnUrl);
  const isDepositAndPay = ReactRedux.useSelector(state => {
    var _state$deposit$instan;
    return (_state$deposit$instan = state.deposit.instantPay) === null || _state$deposit$instan === void 0 ? void 0 : _state$deposit$instan.isDepositAndPay;
  });
  const maxLimitLeft = ReactRedux.useSelector(state => {
    var _state$deposit$maxLim;
    return (_state$deposit$maxLim = state.deposit.maxLimits) === null || _state$deposit$maxLim === void 0 ? void 0 : _state$deposit$maxLim.spendLimitRemaining;
  });
  const [apState, setApState] = useState(APPLEPAY_STATE.INIT);
  const successCleanup = useSuccessCleanup();

  useImperativeHandle(ref, () => ({
    cleanUpSwedbankPayOnDropdownChange: () => {
      var _swedbankPayCheckout, _swedbankPayCheckout$;
      swedbankPayCheckout && ((_swedbankPayCheckout = swedbankPayCheckout) === null || _swedbankPayCheckout === void 0 || (_swedbankPayCheckout$ = _swedbankPayCheckout.cleanUpSwedbankPayTransaction) === null || _swedbankPayCheckout$ === void 0 ? void 0 : _swedbankPayCheckout$.call(_swedbankPayCheckout));
    }
  }));
  useEffect(() => {
    const {
      hasInstantPayAmount
    } = svs.accountservicesReact.deposit.helpers.sharedHelpers;
    const prepareFn = () => setApState(APPLEPAY_STATE.POLL);
    const cleanUpFn = () => {
      setApState(APPLEPAY_STATE.INIT);
      window.scrollTo(0, 0);
    };
    const successFn = async successEventData => {
      setApState(APPLEPAY_STATE.INIT);
      const accountBalance = await successCleanup(successEventData, APPLEPAY);
      if (navigateOnPayTrue(returnUrl)) {
        return;
      }
      dispatch(updateSpendLimitRemainingAction(successEventData.amount));
      await showDepositSuccess(_objectSpread(_objectSpread({}, successEventData), {}, {
        accountBalance
      }), returnUrl);
    };
    const errorFn = (err, transactionData) => {
      logger.info(err, transactionData);
      handleError(err, APPLEPAY, transactionData, maxLimitLeft);
    };
    const options = _objectSpread(_objectSpread({}, baseOptions), {}, {
      prepareFn,
      cleanUpFn,
      successFn,
      errorFn
    });
    if ((swedbankPayProps === null || swedbankPayProps === void 0 ? void 0 : swedbankPayProps.hasBackButton) !== undefined) {
      options.backButton = swedbankPayProps === null || swedbankPayProps === void 0 ? void 0 : swedbankPayProps.hasBackButton;
    }
    if (typeof (swedbankPayProps === null || swedbankPayProps === void 0 ? void 0 : swedbankPayProps.backButtonText) === 'string' && (swedbankPayProps === null || swedbankPayProps === void 0 ? void 0 : swedbankPayProps.backButtonText.length) > 0) {
      options.backButtonText = swedbankPayProps === null || swedbankPayProps === void 0 ? void 0 : swedbankPayProps.backButtonText;
    }
    swedbankPayCheckout = new svs.accountservices.swedbankpay_checkout.SwedbankPayCheckout(options);
    if (instantPay !== null && instantPay !== void 0 && instantPay.isPay) {
      formatAndDeposit(instantPay.amount);
    } else if (hasInstantPayAmount(instantPay)) {
      dispatch(amountChangeAction(instantPay === null || instantPay === void 0 ? void 0 : instantPay.amount));
    }
  }, [dispatch, instantPay, returnUrl, swedbankPayProps === null || swedbankPayProps === void 0 ? void 0 : swedbankPayProps.backButtonText, swedbankPayProps === null || swedbankPayProps === void 0 ? void 0 : swedbankPayProps.hasBackButton, successCleanup, maxLimitLeft]);
  const handleSubmit = (e, isValid) => {
    e.preventDefault();
    if (!isValid) {
      return;
    }
    formatAndDeposit(depositAmount);
  };
  return React.createElement("div", null, React.createElement(Form, {
    method: "post",
    onSubmit: (e, _formData, isValid) => {
      handleSubmit(e, isValid);
    }
  }, apState === APPLEPAY_STATE.INIT && React.createElement(React.Fragment, null, React.createElement(DepositInput, null), isPlayerRegistration && React.createElement(OnboardingDepositAmountInfo, {
    depositAmount: depositAmount
  }), React.createElement(DepositButton, null), React.createElement("p", {
    className: "margin-top-1"
  }, "I n\xE4sta steg slutf\xF6r du ins\xE4ttningen med Apple Pay genom Swedbank Pay", isDepositAndPay ? ' och betalningen genomförs.' : '.')), React.createElement("div", {
    className: SWEDBANKPAY_CONTAINER_ELEMENT
  })));
});
svs.accountservicesReact.deposit.applePay.ApplePay = ApplePay;

 })(window);